import PropTypes from 'prop-types';
// @mui
import { CardContent } from '@mui/material';
// utils
import { fShortenNumber } from 'src/utils/formatNumber';
import {COLORS} from '../../../../constants/colors';
import Iconify from 'src/components/Iconify';
import palette from 'src/theme/palette';
import { Card } from 'src/@/components/ui/card';
import { SkeletonCardInfoDashboard } from 'src/@/components/use/skeleton/SkeletonCardInfoDashboard';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/@/components/ui/tooltip';
import { Info } from 'lucide-react';
// ----------------------------------------------------------------------

export default function WidgetLarge({ title, total, icon, loading, iconColor = 'purple', tooltip }) {
  const getIconBgColor = (color) => {
    const colorMap = {
      blue: 'bg-blue-50',
      green: 'bg-green-50',
      red: 'bg-red-50',
      yellow: 'bg-amber-50',
      purple: 'bg-purple-50',
      indigo: 'bg-indigo-50',
      pink: 'bg-pink-50',
      gray: 'bg-gray-50'
    };
    return colorMap[color] || 'bg-blue-50';
  };

  const getIconTextColor = (color) => {
    const colorMap = {
      blue: 'text-blue-500',
      green: 'text-green-500',
      red: 'text-red-500',
      yellow: 'text-amber-500',
      purple: 'text-purple-500',
      indigo: 'text-indigo-500',
      pink: 'text-pink-500',
      gray: 'text-gray-500'
    };
    return colorMap[color] || 'text-blue-500';
  };

  const getAccentColor = (color) => {
    const colorMap = {
      blue: 'bg-blue-500',
      green: 'bg-green-500',
      red: 'bg-red-500',
      yellow: 'bg-amber-500',
      purple: 'bg-purple-500',
      indigo: 'bg-indigo-500',
      pink: 'bg-pink-500',
      gray: 'bg-gray-400'
    };
    return colorMap[color] || 'bg-blue-500';
  };

  return (
    loading ? (
      <SkeletonCardInfoDashboard />
    ) : (
      <Card className="w-full group hover:shadow-md transition-all duration-300 border border-gray-100 bg-white">
        <div className={`h-0.5 ${getAccentColor(iconColor)}`} />
        <CardContent className="p-4 pb-4">
          <div className="flex items-start justify-between">
            <div className="flex-1 mr-3">
              <div className="flex items-center gap-1.5 mb-2">
                <p className="text-[11px] font-medium uppercase tracking-wider text-gray-400">{title}</p>
                {tooltip && (
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <Info className="w-3 h-3 text-gray-300 cursor-help" />
                      </TooltipTrigger>
                      <TooltipContent side="top" className="max-w-xs text-xs">
                        <p>{tooltip}</p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                )}
              </div>
              <p className="text-2xl font-bold text-gray-900 tracking-tight">
                {typeof total === 'number' ? total.toLocaleString('pt-BR') : total}
              </p>
            </div>
            <div className={`p-2.5 ${getIconBgColor(iconColor)} rounded-lg flex-shrink-0`}>
              <Iconify
                icon={icon}
                className={`h-5 w-5 ${getIconTextColor(iconColor)}`}
                width={20}
                height={20}
              />
            </div>
          </div>
        </CardContent>
      </Card>
    )
  );
}
